let config = null;
const waiting = [];

export function setConfig(c) {
  config = c;
  waiting.forEach((fn) => fn(c));
  waiting.length = 0;
}

export function onConfig(fn) {
  if (config) fn(config);
  else waiting.push(fn);
}

export function getConfig() {
  if (!config) throw new Error("Config not loaded yet");
  return config;
}
